import { connect } from 'react-redux'

import { purchaseGift, fetchPurchasedGifts } from './shopActions'
import Shop from './Shop'

const mapStateToProps = state => ({
  isLoading: state.shop.isLoading,
  notification: state.shop.notification,
  personId: state.authorization.personId,
  gifts: state.shop.gifts
})

const mapDispatchToProps = dispatch => ({
  onPurchase: (personId, giftId) => dispatch(purchaseGift(personId, giftId)),
  fetchGifts: personId => dispatch(fetchPurchasedGifts(personId))
})

const mergeProps = (stateProps, dispatchProps) => ({
  ...stateProps,
  onPurchase: giftId => dispatchProps.onPurchase(stateProps.personId, giftId),
  fetchGifts: () => dispatchProps.fetchGifts(stateProps.personId)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(Shop)
